import styled from 'styled-components';
import { sizes } from '../../variables';

export const Card = styled.div`
  height: ${({ height }) => height};
  border-radius: 8px;
  padding: ${sizes.sm} ${sizes.lg};
  position: relative;
  display: flex;
  align-items: flex-end;
  transition: 0.4s ease-out;
  cursor: pointer;
  margin: ${sizes.sm} ${sizes.xs2};
  box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;

  &:hover {
    transform: scale(1.025);
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
  }

  font-family: Julius Sans One;

  &:hover:before {
    opacity: 1;
  }

  &:hover .info {
    opacity: 1;
    transform: translateY(0px);
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.6);
    z-index: 2;
    transition: 0.5s;
    opacity: 0;
  }

  img {
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
       object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 8px;
  }

  .info {
    width: 100%;
    position: relative;
    z-index: 3;
    color: white;
    opacity: 0;
    transform: translateY(30px);
    transition: 0.5s;
    word-wrap: break-word !important;

    h1 {
      word-wrap: break-word !important;
      margin: 0px;
    }

    p {
      letter-spacing: 1px;
      font-size: 15px;
      margin-top: 8px;
      font-family: Inter;
    }
  }
`